export default __webpack_public_path__ + "assets/png/ed1e3abd8e5f349a669483d3322902d7.png";